export const TAXID_TYPE = {
  BR_CPF: 'BR:CPF',
  BR_CNPJ: 'BR:CNPJ',
  US_SOCIALSECURITY: 'US:SOCIALSECURITY',
} as const;

export interface ITaxID {
  taxID: string;
  type: (typeof TAXID_TYPE)[keyof typeof TAXID_TYPE];
}

export const taxIDFields = (field = 'taxID') => ({
  [field]: {
    taxID: {
      type: String,
      description: 'TaxId could also be used to login in the system',
      index: true,
    },
    type: {
      type: String,
      uppercase: true,
      enum: Object.values(TAXID_TYPE),
    },
  },
});
